module.exports = __webpack_public_path__ + "img/dy.c20a2d02.png";